'use client';

export const getHostOrigin = () => {
  if (typeof window === 'undefined') return '';

  const origin = window.location.origin;

  if (origin.includes('localhost')) {
    return 'http://localhost:3020';
  }

  return origin;
};
